import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { HomeTopArea, SmartDock } from '@/features/home/components';
import { NeonLoadingLine } from '@/components/layout/NeonLoadingLine';
import { QuickReportModal } from '@/features/reports/components/QuickReportModal';

export function HeroDockLayout() {
  const [quickReportOpen, setQuickReportOpen] = useState(false);

  const handleDockAction = useCallback((action: string) => {
    if (action === 'quickReport') setQuickReportOpen(true);
  }, []);

  /* Hide scrollbar so hero goes truly edge-to-edge */
  useEffect(() => {
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.scrollbarWidth = 'none';
    document.documentElement.style.setProperty('-webkit-overflow-scrolling', 'touch');
    const style = document.createElement('style');
    style.textContent = 'html::-webkit-scrollbar { display: none !important; }';
    document.head.appendChild(style);
    return () => {
      document.documentElement.style.overflow = '';
      document.documentElement.style.scrollbarWidth = '';
      document.documentElement.style.removeProperty('-webkit-overflow-scrolling');
      style.remove();
    };
  }, []);

  return (
    <div
      className="-mx-4 sm:-mx-6 md:-mx-8"
      style={{
        marginTop: 'calc(-1.5rem - 12px - env(safe-area-inset-top, 0px))',
        backgroundColor: 'var(--user-page-bg)',
      }}
    >
      <NeonLoadingLine />
      <HomeTopArea showLeftIllustration={false} showTeamImage={false} />
      <NeonLoadingLine />
      <SmartDock onAction={handleDockAction} />
      <Outlet />
      <QuickReportModal
        isOpen={quickReportOpen}
        onClose={() => setQuickReportOpen(false)}
        onSuccess={() => setQuickReportOpen(false)}
      />
    </div>
  );
}
